/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "90d4f5cad5ce34ccc73bb131a09263008299d00f";
